<template>
  <div>
    <ApportionmentReportComp />
  </div>
</template>

<script>
import ApportionmentReportComp from '../../components/apportionment/Reports/ApprotionmentComp.vue';

export default {
  name: 'ApportionmentReport',
  components: {
    ApportionmentReportComp,
  },
};

</script>
